export interface NotificationSettings {
  enabled: boolean;
  recipientUserIds: string[];
  pushNotificationsEnabled: boolean;
  includedInNotificationCenter: boolean;
}

export interface CustomerNotificationConfigResponse {
  customerId: string;
  [key: string]: NotificationSettings | string;
}

// keys are defined by the backend
export const NOTIFICATION_CONFIG_KEYS = [
  'automatedTransferCompletedNotificationSettings',
  'automatedTransferItemPausedNotificationSettings',
  'automatedTransferGeofenceLeftNotificationSettings',
  'automatedTransferGeofenceEnteredNotificationSettings',
  'automatedTransferItemIsBlockedSettings',
  'equipmentDeliveryTimeExceededNotificationSettings',
  'automatedTransferCancelledNotificationSettings',
  'dispositionGeofenceChangesNotificationSettings'
] as const;

export type NotificationConfigKey = typeof NOTIFICATION_CONFIG_KEYS[number];

export type NotificationConfig = Record<NotificationConfigKey, NotificationSettings>;
